import * as React from 'react';
import type { ReactNode } from 'react';
import type { StoreStateProps, StoreDispatchAction, CaseType, State } from './types';

const { createContext, useContext, useReducer } = React;

const initialState = { isLogin: false, protocol: [], priceInfo: null, couponList: [] } as StoreStateProps;

function reducer(state: StoreStateProps, action: StoreDispatchAction): StoreStateProps {
    const cases = {
        onChange: () => {
            return {
                ...state,
                [action.updateKey]: action.value,
            };
        },
    } as CaseType;

    return cases[action.type]() || state;
}

export const StoreContext = createContext(initialState);
export const useContainer = () => useContext(StoreContext);

function StoreProvider({ children, value }: { children: ReactNode; value: Partial<State> }) {
    const mergedInitState = { ...initialState, ...value };
    const [state, dispatch] = useReducer(reducer, mergedInitState);

    return (
        <StoreContext.Provider
            value={{
                ...state,
                onChange: (updateKey, value) => {
                    dispatch({
                        type: 'onChange',
                        updateKey,
                        value,
                    });
                },
            }}
        >
            {children}
        </StoreContext.Provider>
    );
}

export default StoreProvider;
